import { render, staticRenderFns } from "./ResultDialog.vue?vue&type=template&id=5d5b6d53&"
import script from "./ResultDialog.vue?vue&type=script&lang=js&"
export * from "./ResultDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResultDialog.vue?vue&type=style&index=0&id=5d5b6d53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports